import { fa } from 'vuetify/iconsets/fa-svg';

import { $i, skIconAliases } from '@silae/composables';

export const vuetifyIcons = {
	defaultSet: 'fa',
	aliases: {
		...skIconAliases,
		// radioOn: $i('building-memo'),
		info: $i('info-circle')
		// warning: $i('exclamation-circle'),
		// error: $i('cross-circle'),
		// success: $i('check-circle')
	},
	sets: {
		fa
	}
};
